var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.showModal,"width":_vm.width},on:{"input":function($event){return _vm.closeModal()}}},[_c(_vm.modalType,_vm._b({tag:"component",attrs:{"loading":_vm.loading}},'component',_vm.modalProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }